import {Pipe, PipeTransform} from '@angular/core';
import {IconName} from '@fortawesome/fontawesome-common-types';

// based on https://gist.github.com/colemanw/9c9a12aae16a4bfe2678de86b661d922#gistcomment-3269022

// List of official MIME Types: http://www.iana.org/assignments/media-types/media-types.xhtml
@Pipe({name: 'fontawesomeMime', standalone: false})
export class FontawesomeMimePipe implements PipeTransform {

  private iconsByMimeType: Map<string, IconName> = new Map([
    // media
    ['image', 'file-image'],
    ['audio', 'file-audio'],
    ['video', 'file-video'],
    // documents
    ['application/pdf', 'file-pdf'],
    ['application/msword', 'file-word'],
    ['application/vnd.ms-word', 'file-word'],
    ['application/vnd.oasis.opendocument.text', 'file-word'],
    ['application/vnd.openxmlformatsfficedocument.wordprocessingml', 'file-word'],
    ['application/vnd.ms-excel', 'file-excel'],
    ['application/vnd.openxmlformatsfficedocument.spreadsheetml', 'file-excel'],
    ['application/vnd.oasis.opendocument.spreadsheet', 'file-excel'],
    ['application/vnd.ms-powerpoint', 'file-powerpoint'],
    ['application/vnd.openxmlformatsfficedocument.presentationml', 'file-powerpoint'],
    ['application/vnd.oasis.opendocument.presentation', 'file-powerpoint'],
    ['text/plain', 'file-alt'],
    ['text/html', 'file-code'],
    ['text/csv', 'file-csv'],
    ['application/json', 'file-code'],
    // archives
    ['application/gzip', 'file-archive'],
    ['application/zip', 'file-archive']
  ]);

  transform(mimeType: string): IconName {
    const icon =  this.iconsByMimeType.get(mimeType);
    return icon ? icon : 'file';
  }
}
